import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from 'src/app/shared/services/message.service';
import { Farm } from 'src/app/shared/dtos/Farm';
import { FarmWithImages } from 'src/app/shared/dtos/FarmWithImages';
import { environment } from 'src/environments/environment';
import { FarmDTOGeneric } from 'src/app/shared/dtos/FarmDTOGeneric';
import { portugal } from 'src/app/shared/constants/portugal';
import { provinces } from 'src/app/shared/constants/provinces';
import { countries } from 'src/app/shared/constants/countries';
import { FarmFilters } from 'src/app/shared/dtos/FarmFilters';
import { Province } from 'src/app/shared/dtos/Province';
import { TownHall } from 'src/app/shared/dtos/TownHall';
import { District } from 'src/app/shared/dtos/District';
import { Municipality } from 'src/app/shared/dtos/Municipality';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  private serverUrl = environment.serverUrl + 'location';  // URL to web api

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private messageService: MessageService) { }

  getProvincesSpain (): Observable<Province[]> {
    return this.http.get<Province[]>(this.serverUrl + '/provinces')
      .pipe(
        tap(_ => this.log('fetched provinces')),
        catchError(this.handleError<Province[]>('getProvinces', []))
      );
  }

  /** GET farm by id. Will 404 if id not found */
  getTownHallsByIdProvince(idProvince: number): Observable<TownHall[]> {
    const url = `${this.serverUrl}/provinces/${idProvince}/townHalls`;
    return this.http.get<TownHall[]>(url).pipe(
      tap(_ => this.log(`fetched townhalls by idProvince=${idProvince}`)),
      catchError(this.handleError<TownHall[]>(`getTownhalls by idProvince=${idProvince}`))
    );
  }

  getDistrictsPortugal(): Observable<District[]> {
    return this.http.get<District[]>(this.serverUrl + '/districts')
    .pipe(
      tap(_ => this.log('fetched districts')),
      catchError(this.handleError<District[]>('getDistricts', []))
    );

  }

  getMunicipalitiesByIdDistricts(idDistrict: number): Observable<Municipality[]> {
    const url = `${this.serverUrl}/districts/${idDistrict}/municipalities`;
    return this.http.get<Municipality[]>(url).pipe(
      tap(_ => this.log(`fetched municipalities by districts=${idDistrict}`)),
      catchError(this.handleError<Municipality[]>(`getMunicipalities by idDistricts=${idDistrict}`))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


   /** Log a FarmService message with the MessageService */
   private log(message: string) {
    this.messageService.add(`Farm Service: ${message}`);
  }


}
